<form [formGroup]="productForm">
  <div class="form-field">
    <input
      id="productType"
      name="productType"
      formControlName="productType"
      avanoInputText
      readonly
      [label]="translationKeys.productDeclaration.html.type | translate"
    />
  </div>
  <div class="form-field">
    <input id="name" name="name" formControlName="name" avanoInputText readonly [label]="productForm.get('productType').value | productTypeLabel | translate" />
  </div>
  <div class="form-field">
    <input
      id="primaryArticleIdentifierValue"
      name="primaryArticleIdentifierValue"
      avanoInputText
      formControlName="primaryArticleIdentifierValue"
      [readonly]="!canEditArticleIdentifier"
      [label]="translationKeys.productDeclaration.html.partNumber | translate"
      [avanoValidationErrorSupport]="primaryArticleIdentifier"
      [avanoValidationErrorLabel]="translationKeys.productDeclaration.html.partNumber | translate"
    />
    <ng-container *ngIf="primaryArticleIdentifier.errors && primaryArticleIdentifier.touched">
      <span class="error-message" *ngIf="primaryArticleIdentifier.errors.required">
        {{ translationKeys.commonTranslationKey.validation.error.required.input | translate }}
      </span>
    </ng-container>
  </div>
  <ng-container *scipRequiresFeature="feature.SHOW_SUPPLIERREFERENCE">
    <div class="form-field">
      <input
        id="imdsScipNumber"
        name="imdsScipNumber"
        formControlName="imdsScipNumber"
        avanoInputText
        maxlength="255"
        [label]="translationKeys.declarationNodeDetailsComponent.html.label.imdsScipNumber | translate"
        [readonly]="!canEditSupplierReference"
        [avanoValidationErrorSupport]="imdsScipNumber"
        [avanoValidationErrorLabel]="translationKeys.declarationNodeDetailsComponent.html.label.imdsScipNumber | translate"
      />
    </div>
    <ng-container *ngIf="imdsScipNumber.errors && imdsScipNumber.touched">
      <span class="error-message" *ngIf="imdsScipNumber.errors.whitespace">
        {{ translationKeys.declarationNodeDetailsComponent.html.imdsScipNumberNotSpaces | translate }}
      </span>
      <span class="error-message" *ngIf="!imdsScipNumber.errors.whitespace && imdsScipNumber.errors.uuid">
        {{ translationKeys.declarationNodeDetailsComponent.html.imdsScipNumberFormatNotValid | translate }}
      </span>
    </ng-container>

    <div class="form-field" *ngIf="false">
      <input
        id="imdsScipSubmissionNumber"
        name="imdsScipSubmissionNumber"
        formControlName="imdsScipSubmissionNumber"
        avanoInputText
        [label]="translationKeys.declarationNodeDetailsComponent.html.label.imdsScipSubmissionNumber | translate"
        readonly
      />
    </div>
    <div class="form-field" *ngIf="false">
      <avano-radio-checkbox-group
        [label]="translationKeys.declarationNodeDetailsComponent.html.label.isValidImdsScipNumber | translate"
        [alignHorizontal]="true"
      >
        <avano-radiobutton name="isValidImdsScipNumber" [value]="false" formControlName="isValidImdsScipNumber" [disabled]="true">
          {{ translationKeys.declarationNodeDetailsComponent.useImdsScipNumber.radioButtonLabel.no | translate }}
        </avano-radiobutton>
        <avano-radiobutton name="isValidImdsScipNumber" [value]="true" formControlName="isValidImdsScipNumber" [disabled]="true">
          {{ translationKeys.declarationNodeDetailsComponent.useImdsScipNumber.radioButtonLabel.yes | translate }}
        </avano-radiobutton>
      </avano-radio-checkbox-group>
    </div>

    <div class="form-field">
      <avano-radio-checkbox-group
        [label]="translationKeys.declarationNodeDetailsComponent.useImdsScipNumber.groupDescription | translate"
        [alignHorizontal]="true"
      >
        <avano-radiobutton name="useImdsScipNumber" [value]="false" formControlName="useImdsScipNumber" [disabled]="!canEditSupplierReference">
          {{ translationKeys.declarationNodeDetailsComponent.useImdsScipNumber.radioButtonLabel.no | translate }}
        </avano-radiobutton>
        <avano-radiobutton name="useImdsScipNumber" [value]="true" formControlName="useImdsScipNumber" [disabled]="!canEditSupplierReference">
          {{ translationKeys.declarationNodeDetailsComponent.useImdsScipNumber.radioButtonLabel.yes | translate }}
        </avano-radiobutton>
      </avano-radio-checkbox-group>
    </div>
  </ng-container>
  <div class="form-field">
    <label>{{ translationKeys.declarationNodeDetailsComponent.html.otherArticleIdentifiersLabel | translate }}</label>
    <p-autoComplete formControlName="otherArticleIdentifiers" avanoSelectFieldMultiple (selectButtonClick)="openOtherArticleIdentifierDialog()">
      <ng-template let-singleOtherArticleIdentifier pTemplate="selectedItem">
        <span class="p-autocomplete-token-label" scipSpacesAsIs avanoEllipsis [useNoWrap]="false">
          {{ singleOtherArticleIdentifier | otherArticleIdentifierLabel | translate }}: {{ singleOtherArticleIdentifier.value }}
        </span>
      </ng-template>
    </p-autoComplete>
  </div>
  <div class="form-field">
    <label>{{ translationKeys.declarationNodeDetailsComponent.html.otherNamesLabel | translate }}</label>
    <p-autoComplete formControlName="otherArticleNames" avanoSelectFieldMultiple (selectButtonClick)="openOtherNameDialog()">
      <ng-template let-item pTemplate="selectedItem">
        <span class="p-autocomplete-token-label" scipSpacesAsIs avanoEllipsis [useNoWrap]="false">
          {{ item | otherNameLabel | translate }}: {{ item.text }}
        </span>
      </ng-template>
    </p-autoComplete>
  </div>
  <div class="form-field">
    <label for="productionInEUSelect">{{ translationKeys.declarationNodeDetailsComponent.html.acInEuTypes | translate }}</label>
    <input type="hidden" formControlName="productionInEU" />
    <p-autoComplete
      id="productionInEUSelect"
      name="productionInEUSelect"
      field="label"
      [suggestions]="inEUTypeSuggestions"
      (completeMethod)="filterInEUTypes($event)"
      [formControl]="productionInEuSuggestions"
      [dropdown]="true"
      [forceSelection]="true"
      (onSelect)="productionInEUChanged($event)"
      [avanoValidationErrorSupport]="productionInEU"
      [avanoValidationErrorLabel]="translationKeys.declarationNodeDetailsComponent.html.acInEuTypes | translate"
    >
    </p-autoComplete>

    <span class="error-message" *ngIf="!productionInEuSuggestions.valid && productionInEuSuggestions.touched">{{
      translationKeys.commonTranslationKey.validation.error.required.selection | translate
    }}</span>
  </div>
  <div class="form-field">
    <label>{{ translationKeys.declarationNodeDetailsComponent.html.acArticleArticleCategory | translate }} </label>
    <p-autoComplete formControlName="articleCategories" avanoSelectFieldMultiple (selectButtonClick)="openInformationArticleCategoryDialog()">
      <ng-template let-value pTemplate="selectedItem">
        <span class="p-autocomplete-token-label" [title]="value | articleCategoryChip: true">{{ value | articleCategoryChip }}</span>
      </ng-template>
    </p-autoComplete>
  </div>
  <div class="form-field" *ngIf="showVdaMatCat">
    <label for="vdaMaterialCategories">{{ translationKeys.declarationNodeDetailsComponent.html.vdaMaterialCategoriesLabel | translate }}</label>
    <input id="vdaMaterialCategories" type="hidden" formControlName="vdaMaterialCategories" name="vdaMaterialCategories" />
    <input avanoInputText type="text" [value]="vdaMaterialCategories?.value | categoryName" readonly />
  </div>
  <div class="form-field" *ngIf="showVdaMixCat">
    <label for="vdaMixtureCategories">{{ translationKeys.declarationNodeDetailsComponent.html.vdaMixtureCategoriesLabel | translate }}</label>
    <input id="vdaMixtureCategories" type="hidden" formControlName="vdaMixtureCategories" name="vdaMixtureCategories" />
    <input avanoInputText type="text" [value]="vdaMixtureCategories?.value | categoryName" readonly />
  </div>
  <div class="form-field">
    <label>{{ translationKeys.declarationNodeDetailsComponent.html.acArticleMaterialCategory | translate }}</label>
    <p-autoComplete
      formControlName="materialCategories"
      avanoSelectFieldMultiple
      (selectButtonClick)="openMaterialCategoryDialog()"
      (onUnselect)="updateShowOtherMatCatTextField()"
    >
      <ng-template let-value pTemplate="selectedItem">
        <span class="p-autocomplete-token-label" [title]="value | materialCategoryChip: true">{{ value | materialCategoryChip }}</span>
      </ng-template>
    </p-autoComplete>
  </div>
  <div class="form-field" [class.hidden]="!showOtherMatCatTextField">
    <textarea
      id="otherMatCatText"
      name="otherMatCatText"
      formControlName="otherMatCatText"
      avanoInputTextarea
      [isExpandingTextField]="true"
      [label]="translationKeys.declarationNodeDetailsComponent.html.otherMaterialCategoryText | translate"
      [tooltip]="translationKeys.declarationNodeDetailsComponent.html.otherMaterialCategoryTextTooltip | translate"
      maxlength="255"
    ></textarea>
  </div>
  <div class="form-field">
    <label>{{ translationKeys.declarationNodeDetailsComponent.html.acArticleMixtureCategory | translate }}</label>
    <p-autoComplete formControlName="mixtureCategories" avanoSelectFieldMultiple (selectButtonClick)="openMixtureCategoryDialog()">
      <ng-template let-value pTemplate="selectedItem">
        <span class="p-autocomplete-token-label" [title]="value | mixtureCategoryChip: true">{{ value | mixtureCategoryChip }}</span>
      </ng-template>
    </p-autoComplete>
  </div>

  <div class="form-field">
    <avano-radio-checkbox-group
      [label]="translationKeys.declarationNodeDetailsComponent.safeuseinstructions.groupDescription | translate"
      [alignHorizontal]="true"
    >
      <avano-radiobutton name="provideSafeUseInstruction" [value]="false" formControlName="provideSafeUseInstruction">
        {{ translationKeys.declarationNodeDetailsComponent.safeuseinstructions.radioButtonLabel.noNeedToProvide | translate }}
      </avano-radiobutton>
      <avano-radiobutton name="provideSafeUseInstruction" [value]="true" formControlName="provideSafeUseInstruction">
        {{ translationKeys.declarationNodeDetailsComponent.safeuseinstructions.radioButtonLabel.provide | translate }}
      </avano-radiobutton>
    </avano-radio-checkbox-group>
  </div>
  <div class="form-field">
    <textarea
      avanoInputTextarea
      [isExpandingTextField]="true"
      [label]="translationKeys.declarationNodeDetailsComponent.safeuseinstructions.textAreaLabel.safeUseInstructionText | translate"
      maxlength="2000"
      formControlName="customSUIText"
      name="customSUIText"
    ></textarea>
  </div>
  <div class="form-field" *ngIf="showSuiRolledUp">
    <label for="resolution-username">{{ translationKeys.declarationNodeDetailsComponent.html.combinedSUILabel | translate }}</label>
    <div id="resolution-username" class="suirollup-container">
      <div class="suirollup-item" *ngFor="let singleSui of suiRolledUp">
        {{ singleSui.text }}
      </div>
    </div>
  </div>
  <ng-container *ngIf="showDossierInfo" formGroupName="dossier">
    <div>
      <label
        ><b>{{ translationKeys.declarationNodeDetailsComponent.html.heading.scipInformation | translate }}</b></label
      >
    </div>
    <div class="form-field">
      <label>{{ translationKeys.declarationNodeDetailsComponent.html.dossierStatusLabel | translate }}</label>
      <input type="hidden" name="dossierStatus" formControlName="status" />
      <input avanoInputText readonly type="text" [value]="this.dossierStatus?.value | dossierStateTranslationKey | translate" />
    </div>
    <div class="form-field">
      <label>{{ translationKeys.declarationNodeDetailsComponent.html.scipNumberLabel | translate }}</label>
      <input avanoInputText readonly type="text" name="scipNumber" formControlName="scipNumber" />
    </div>
    <div class="form-field" formGroupName="org">
      <label>{{ translationKeys.declarationNodeDetailsComponent.html.organizationLabel | translate }}</label>
      <input avanoInputText readonly type="text" name="organization" formControlName="name" />
    </div>
    <div class="form-field">
      <label>{{ translationKeys.declarationNodeDetailsComponent.html.submissionNumberLabel | translate }}</label>
      <input avanoInputText readonly type="text" name="submissionNumber" formControlName="submissionNumber" />
    </div>
    <div *ngIf="dossier | canDownloadDossier" class="form-button-group">
      <ng-container
        *ngIf="{
          isInDownload: dossier.dossierId | isInDownload | async
        } as data"
      >
        <button
          avanoButton
          [disabled]="data.isInDownload"
          [icon]="data.isInDownload ? 'pi pi-spin pi-spinner' : 'icon-content-download'"
          (click)="downloadDossier(data.isInDownload)"
          [label]="translationKeys.declarationNodeDetailsComponent.html.label.downloadDossier | translate"
        ></button>
      </ng-container>
      <button
        *ngIf="showOpenInECHABtn"
        avanoButton
        icon="icon-content-hyperlink"
        [label]="translationKeys.declarationNodeDetailsComponent.html.label.openInEcha | translate"
        (click)="openLinks()"
      ></button>
    </div>
  </ng-container>
  <div class="form-field">
      <label class="force-resubmission-checkbox" *ngIf="allowForceResubmission">
        <input type="checkbox" [value]="true" formControlName="forceResubmission" name="forceResubmission">
        <span class="checkmark"></span>
        {{ translationKeys.declarationNodeDetailsComponent.html.forceResubmissionLabel | translate }}
      </label>
  </div>
</form>

<scip-article-category-select-dialog
  *ngIf="displayArticleCategorySelection"
  [selectedCategories]="articleCategories?.value"
  (saveEvent)="saveArticleCategory($event)"
  (cancelEvent)="closeArticleCategoryDialog()"
></scip-article-category-select-dialog>

<scip-material-selection-dialog
  *ngIf="displayMaterialCategorySelection"
  [selectedCategories]="materialCategories?.value"
  (saveEvent)="saveMaterialCategory($event)"
  (cancelEvent)="closeMaterialCategoryDialog()"
></scip-material-selection-dialog>

<scip-mixture-selection-dialog
  *ngIf="displayMixtureCategorySelection"
  [selectedCategories]="mixtureCategories?.value"
  (saveEvent)="saveMixtureCategory($event)"
  (cancelEvent)="closeMixtureCategoryDialog()"
></scip-mixture-selection-dialog>

<scip-other-article-identifier-dialog
  *ngIf="displayOtherArticleIdentifierSelection"
  [otherArticleIdentifiers]="otherArticleIdentifiers?.value"
  (closeEvent)="closeDialog()"
  (saveEvent)="saveOtherArticleIdentifiers($event)"
>
</scip-other-article-identifier-dialog>

<scip-other-name-dialog
  *ngIf="displayOtherNameSelection"
  [otherNames]="otherArticleNames?.value"
  (saveEvent)="saveOtherNames($event)"
  (cancelEvent)="closeOtherNameDialog()"
></scip-other-name-dialog>
